import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from 'react-bootstrap';

import UnstyledDropdownToggle from 'components/bootstrap_extensions/unstyled_dropdown_toggle';

export default function FloorPlanRow({ floorPlan, onDelete, onReplace }) {
  const photoPreviewStyle = {
    backgroundImage: `url(${floorPlan.thumbnailUrl})`
  };

  // TODO: Eventually if we decide this needs to be a card or something later, we can use mediaUiUpdate to show new UI
  const oldPhotoRowBody = () => {
    return (
      <div className="old-media-tab">
        <div className="photo-row shadowed bottom-buffer-sm" name="floor-plan-container">
          <div className="row">
            <div className="col-xs-3">
              <div className="js-photo-preview" style={photoPreviewStyle}></div>
            </div>
            <div className="col-xs-9">
              <div className="photo-inputs-container">
                <div className="photo-inputs">
                  <div className="row">
                    <div className="col-xs-9"></div>
                    <div className="col-xs-3 col-lg-3 text-center">
                      <Dropdown className="photo-options" id={floorPlan.id || floorPlan.uploadId}>
                        <UnstyledDropdownToggle bsRole="toggle">
                          <i className="fas fa-cog fa-lg text-muted clickable settings-icon" />
                        </UnstyledDropdownToggle>
                        <Dropdown.Menu className="photoOptions">
                          <MenuItem
                            eventKey="1"
                            name="deletePlanButton"
                            onClick={onDelete}
                          >
                            Delete
                          </MenuItem>
                          <MenuItem
                            eventKey="2"
                            name="replacePlanButton"
                            onClick={onReplace}
                          >
                            Replace Plan
                          </MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      { oldPhotoRowBody() }
    </React.Fragment>
  );
}

FloorPlanRow.propTypes = {
  floorPlan: PropTypes.shape({
    id: PropTypes.number,
    uploadId: PropTypes.number,
    thumbnailUrl: PropTypes.string
  }),
  onDelete: PropTypes.func.isRequired,
  onReplace: PropTypes.func.isRequired
};
